@if (canManageProviderData) {
  @if (!loading) {
    @if (showAssignmentsLabel) {
      <h5>Assignments</h5>
    }
    <ng-select
      bindValue="id"
      bindLabel="fullName"
      name="assignedToIds"
      placeholder="Filter by Assigned Users"
      [items]="assignedToUsers"
      [clearable]="false"
      [(ngModel)]="assignedToId"
      class="d-inline-block text-start w-50"
    />
    @if (displayForList) {
      <span>
        <button class="btn btn-primary" (click)="onUpdate()">Assign</button>
        <button class="btn btn-secondary" (click)="onClearSelection()">Clear Selection</button>
      </span>
    } @else {
      <span>
        <button class="btn btn-sm btn-secondary" (click)="onCancel()"><fa-icon [icon]="['fas', 'times']" /></button>
        <button class="btn btn-sm btn-primary" (click)="onUpdate()"><fa-icon [icon]="['fas', 'check']" /></button>
      </span>
    }
  } @else {
    <mat-spinner [diameter]="30" />
  }
}